import { useAuthStore, useUserStore } from '../../stores';
import { IconLabelList } from '@bloomays-lib/ui.shared';

const AuthInfo = () => {
  const auth = useAuthStore((state) => state.auth);
  const user = useUserStore((state) => state.user);

  return (
    <IconLabelList
      list={[
        { text: 'AuthLoading:', span: `${auth?.isLoading}` },
        { text: 'Authenticated:', span: `${auth?.isAuthenticated}` },
        { text: 'AuthUser:', span: `${auth?.user?.displayName}` },
        { text: 'ProfileUser:', span: `${user?.profile.displayName}` },
      ]}
    />
  ) as React.ReactNode;
};

export default AuthInfo;
export { AuthInfo };
